import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import styles from './PageHeader.module.scss';

interface PageHeaderProps {
    title: React.ReactNode;
    description?: React.ReactNode;
    actions?: React.ReactNode;
    badge?: React.ReactNode;
    onBack?: () => void;
    below?: React.ReactNode;
    className?: string;
}

// Page title row from the Enterprise designs: back arrow, 24px title, grey description, actions on the right.
export const PageHeader: React.FC<PageHeaderProps> = ({
    title,
    description,
    actions,
    badge,
    onBack,
    below,
    className
}) => (
    <header className={clsx(styles.root, className)}>
        <div className={styles.headings}>
            <div className={styles.titleRow}>
                {onBack && (
                    <button
                        type="button"
                        aria-label="Back"
                        className={styles.back}
                        onClick={onBack}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                )}
                <h1 className={styles.title}>{title}</h1>
                {badge}
            </div>
            {description && <p className={clsx(styles.description, { [styles.indented]: onBack })}>{description}</p>}
            {below && <div className={styles.below}>{below}</div>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
    </header>
);

export default PageHeader;
